module.exports = __webpack_public_path__ + "img/echo.81a68754.png";